import React from 'react';

const About: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-primary text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white">Qui sommes-nous</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Une organisation chrétienne dédiée au bien-être de la femme et de l'enfant
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <h2 className="text-3xl font-bold mb-6">Présentation</h2>
              <p className="mb-4">
                MORE LOVE Inc. (Plus d'amour) est une ONG Chrétienne de droit Américain, 
                créée dans l'État du Maryland aux États-Unis, reconnue comme une organisation 
                à but non lucrative sous le code 501(C)(3).
              </p>
              <p className="mb-4">
                Elle fédère en son sein des Associations et ONG œuvrant pour le bien-être 
                de la femme et de l'enfant.
              </p>
              <p>
                Notre organisation s'engage à partager l'amour de Jésus-Christ à travers 
                l'évangélisation et les œuvres sociales, en mettant l'accent sur le soutien 
                aux femmes et aux enfants dans le besoin.
              </p>
            </div>
            <div className="flex justify-center">
              <div className="rounded-lg overflow-hidden shadow-xl">
                <img 
                  src="/logo.jpeg" 
                  alt="MoreLove Logo" 
                  className="w-full h-auto max-w-md"
                />
              </div>
            </div>
          </div>

          {/* Objective Section */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold mb-6 text-center">Notre objectif</h2>
            <div className="max-w-3xl mx-auto">
              <p className="text-lg mb-4 text-center">
                L'objectif principal de More Love est de rassembler des femmes leaders 
                sauvées par le Seigneur Jésus-Christ, autour d'un idéal qui est le bien être 
                de la femme et de l'enfant.
              </p>
              <blockquote className="text-xl text-center my-8">
                « Le Seigneur dit une parole et les messagères de bonnes nouvelles sont une grande armée »
                <footer className="mt-2">Psaumes 68:12</footer>
              </blockquote>
            </div>
          </div>

          {/* Leadership Section */}
          <div>
            <h2 className="text-3xl font-bold mb-10 text-center">Notre leadership</h2>
            <div className="max-w-4xl mx-auto">
              <div className="card mb-8">
                <h3 className="text-2xl font-bold mb-4">La présidente internationale</h3>
                <p className="mb-4">
                  La Révérende Akissi Victorine KOUADIO nommée Deborah, est la Présidente de 
                  l'Eglise Mission Internationale Christ en Vous l'Esperance de la Gloire (MICEG).
                </p>
                <p className="mb-4">
                  Convaincue que la femme a un réel rôle à jouer pour l'expansion de l'évangile et 
                  l'entraide, elle fonde l'ONG MIFEC (Mouvement Internationale des Femmes Chrétienne) en 2001.
                </p>
                <p>
                  Apporter une solution à la précarité sociale et économique pour la femme et l'enfant 
                  nécessitant des mains d'associations, elle crée la Fédération MORE LOVE (plus d'amour) en 2019.
                </p>
              </div>
              <div className="text-center">
                <p className="text-lg font-bold">
                  DES FEMMES CHRÉTIENNES LEADERS AU SERVICE DE LA COMMUNAUTÉ
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
